import styled from 'styled-components';

export const Text = styled.p`
  padding-bottom: 10px;
`;

export const Wrapper = styled.div`
  text-align: center;
`;
